
var Banners = function()
{

	/**
	 * [getAttributes description]
	 * @param  {[type]} node [description]
	 * @return {[type]}      [description]
	 */
	var getAttributes = function( node )
	{
		var attributes = {};
		for( var i in node.attributes ) {
			if( node.attributes.hasOwnProperty( i ) ) {
				attributes[node.attributes[i].name] = node.attributes[i].nodeValue;
			}
		}
		return attributes;
	};

	var modal;

	var modalResponse = function( response, attributes, callbacks ){
		if( typeof modal !== 'undefined' ) {
			modal.modal('close');
		}
		modal = $(response);
		modal.modal({
			observeChanges : false,
        	onVisible : function() {
        		var modalObj = $(this);
        		var button = $('.ui.button', modalObj);
        		var _token = $('[name="_token"]', modalObj).val();
        		var form = $('.ui.form', modalObj);

        		button.each(function(){
        			$(this).click( function(e){
        				e.preventDefault();
        				if( form.length && button[0].tagName.toLowerCase() === 'button' ) {
			    			var action = form.attr('action');
			    		} else {
			    			var action = $(this).attr('href');
			    		}
	        			callbacks.onSave( $(this), modalObj );
							var ajaxOptions = {
	                        type: 'GET',
	                        async: false,
	                        url: action,
	                        data : $('input, select, textarea', form).not('[name="_token"]').serialize(),
	                        success: function( response ){
	                        	if( $(response)[0].id ) {
	                        		callbacks.onComplete( response, attributes, modal );
	                        	} else {
	                        		modalResponse( response, attributes, callbacks );
	                        	}
	                        },
	                        error: function ( xhr, textstatus, errorThrown ) {
	                        	switch( xhr.status ) {
	                        		case 422 :
	                        			var errors = [];
	                        			/** Validation error */
	                        			var response = JSON.parse( xhr.responseText );
	                        			for( var i in response ) {
	                        				errors.push( response[i][0] );
	                        			}
	                        			modalError( errors, modal );
	                        		break;
	                        		default :
	                        			modalError( ['Unknown error has occurred: ["' + xhr.status + '","' + textstatus + '"]'], modal );
	                        		break;
	                        	}
	                        	callbacks.onError( modalObj, xhr );
	                        }
	                    };

	                    if( form.length ) {
	                    	ajaxOptions.headers = {
	                        	'X-CSRF-TOKEN' : _token
	                        };
	                        ajaxOptions.type = 'POST';
	                    }

	        			$.ajax(ajaxOptions);
	        		});
        		});
				callbacks.onVisible( modalObj );
        	}
    	}).modal('show');
	};

	/**
	 * [modalEdit description]
	 * @param  {[type]} _this [description]
	 * @return {[type]}       [description]
	 */
	var modalEdit = function( node, _callbacks )
	{
		_callbacks = _callbacks || {};
		var callbacks = $.extend({
			onVisible : function(){},
			onComplete : function(){},
			onError : function(){},
			onSave : function(){},
			onResponse : function(){},
			closeModal : true
		}, _callbacks);

		var attributes = getAttributes(node);
		$.get( attributes.href, function( response ) {
			callbacks.onResponse(response, attributes);
			modalResponse( response, attributes, callbacks );
		});
	};

	/**
	 * [select description]
	 * @param  {[type]} selector [description]
	 * @param  {[type]} el       [description]
	 * @return {[type]}          [description]
	 */
	var select = function( selector, el ) {
		if ( ! el ) { el = document; }
		return Array.prototype.slice.call( el.querySelectorAll( selector ) );
	};

	/**
	 * [wysiwyg description]
	 * @return {[type]} [description]
	 */
	var wysiwyg = function()
	{
		$('.redactor').redactor({
			minHeight : 300,
			toolbarFixed : false
		});
	};

	/**
	 * [slide description]
	 * @return {[type]} [description]
	 */
	this.slide = function()
	{

		var app = this;

		/**
		 * [updateSlideRows description]
		 * @param  {[type]} response [description]
		 * @return {[type]}          [description]
		 */
		this.updateSlideRows = function( response )
		{

		};

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function()
		{

			/**
			 * [bindEvents description]
			 * @return {[type]} [description]
			 */
			var bindEvents = function()
			{

			};

			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function()
			{
				bindEvents();
				wysiwyg();
			};

		};
	}

	this.banner = function()
	{

		/**
		 * [description]
		 * @return {[type]} [description]
		 */
		return new function()
		{

			/**
			 * [sorter description]
			 * @return {[type]} [description]
			 */
			var sorter = function(){
				$('.orderable').rowSorter({
					onDrop: function( tbody, row, new_index, old_index ) {
				        var table = $(tbody.tagName.toLowerCase() === "tbody" ? tbody.parentNode : tbody);
				        var ids = [];
				        $('tbody tr', table).each(function(){
				        	ids.push( $(this).attr('data-field-id') );
				        });
				        $.ajaxSetup({
				            headers: { 'X-CSRF-TOKEN': $('[name="_token"]').val() }
				        });
				        $.post( $('#order-url').val(), { orders : ids }, function( response ){
				        	console.log(response);
				        });
				    },
				});
			};

			/**
			 * [bindEvents description]
			 * @return {[type]} [description]
			 */
			var bindEvents = function()
			{

			};

			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function()
			{
				sorter();
			};

		};

	};

};


jQuery(document).ready( function($){


	var app = new Banners();

	if( $('.create.banner-slide, .edit.banner-slide').length ) {
		var slide = app.slide();
		slide.init();
	}

	if( $('.create.banner, .edit.banner').length ) {
		var banner = app.banner();
		banner.init();
	}

});